// utils/dateHelper.js

export const formatDate = (date, locale = "en-GB") => {
    if (!date) return "--";

    try {
        return new Date(date).toLocaleDateString(locale, {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    } catch (error) {
        return "--";
    }
};

/**
 * 
 * @param {*} dateString 
 * @returns 
 */

export const formatShortDate = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);

    if (isNaN(date)) return '';

    return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
    });
};


/**
 * 
 * @param {*} dateString 
 * @returns 
 */

export const formatFullDate = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);

    if (isNaN(date)) return '';

    return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
};